import type { IconProps } from "@/components/icons/svgDefaults";
import { svgDefaults } from "@/components/icons/svgDefaults";

export function FreeSpinsIcon(props: IconProps) {
  const stroke = { stroke: "white", strokeWidth: "3.7987", strokeLinecap: "round", strokeLinejoin: "round" } as const;

  return (
    <svg viewBox="0 0 47 60" {...svgDefaults} {...props}>
      <path d="M14.733 14.8167H32.8417L41.896 30.1394L32.8417 45.4621H14.733L5.67866 30.1394L14.733 14.8167Z" {...stroke} />
      <path d="M23.7876 23.1746V37.1043" {...stroke} />
      <path d="M16.8227 30.1392H30.7524" {...stroke} />
      <path d="M43.4844 10.4423C38.2599 5.21943 31.1751 2.2854 23.7877 2.2854C16.4004 2.2854 9.31548 5.21943 4.09105 10.4423" {...stroke} />
      <path d="M4.09105 49.8359C9.31548 55.0588 16.4004 57.9928 23.7877 57.9928C31.1751 57.9928 38.2599 55.0588 43.4844 49.8359" {...stroke} />
      <path d="M8.46484 48.2478H2.89295V53.8197" {...stroke} />
      <path d="M39.1102 12.0304H44.6821V6.4585" {...stroke} />
    </svg>
  );
}
